import React from "react";
import { useSelector } from "react-redux";
import PassChange from "./PassChange";
import DangerZone from "./DangerZone";

function Genral() {
  const user = useSelector((state) => state.user.user);

  return (
    <div className="w-full  space-y-6">
      {/* General Info Section */}
      <div className="bg-white border border-gray-200 shadow rounded-2xl p-4 md:p-6 space-y-5">
        <h3 className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-800">
          General
        </h3>

        <div className="flex flex-col space-y-3 text-gray-700 text-sm sm:text-base md:text-lg">
          <div className="flex flex-col sm:flex-row sm:items-center gap-2">
            <span className="font-medium">Email:</span>
            <span className="flex-1 px-3 py-1 bg-gray-100 border rounded-md italic tracking-wide">
              {user?.email}
            </span>
          </div>

          <PassChange />
        </div>
      </div>

      {/* Divider */}
      <div className="flex items-center text-xs sm:text-sm md:text-base text-red-500">
        <div className="flex-1 h-px bg-red-300"></div>
        <span className="px-4 uppercase tracking-wider font-semibold whitespace-nowrap">
          Danger Zone
        </span>
        <div className="flex-1 h-px bg-red-300"></div>
      </div>

      {/* DangerZone Component */}
      <DangerZone />
    </div>
  );
}

export default Genral;
